import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { OvertimeGetSummaryResponse, OvertimeGetSummaryVariables } from '../types';

const getOvertimeSummaryQuery = gql`
  query OvertimeGetSummary($input: OvertimeGetSummaryInput!) {
    overtimeGetSummary(input: $input) {
      code
      success
      message
      data {
        data {
          userId
          empId
          name
          workingDays
          totalOtHours
          totalOtAmountPaise
        }
        page
        pageSize
        total
      }
    }
  }
`;

const getOvertimeSummary = (queryVariables: OvertimeGetSummaryVariables) => {
  return graphQLApi<OvertimeGetSummaryResponse, OvertimeGetSummaryVariables>({
    query: getOvertimeSummaryQuery,
    queryVariables,
  });
};

export default getOvertimeSummary;
